import Person from "./models/Person";
import Student from "./models/Student";
import Teacher from "./models/Teacher";
import "./style.css";

function App() {

  const people = [
    new Person("NEHA", 30),
    new Student("WASEEM", 20, "Computer Science"),
    new Teacher("Dr. James Wilson", 45, "Mathematics")
  ];

  return (
    <div className="container">
      <h1>Person Class Hierarchy</h1>

      {people.map((person, index) => (
        <div className="card" key={index}>
          <h2>
            {person.name} ({person.constructor.name})
          </h2>

          <p>Age: {person.age}</p>

          <p className="intro">{person.introduce()}</p>

          {"major" in person && <p><b>Major:</b> {person.major}</p>}
          {"subject" in person && <p><b>Teaching:</b> {person.subject}</p>}
        </div>
      ))}
    </div>
  );
}

export default App;